/***
 * 숫자포맷
 */

//International api
const intl = new Intl.NumberFormat();

Number.prototype.percentFormat = function () {
  return (Math.round(this * 10000)/100).numberFormat() + "%";
};

Number.prototype.numberFormat = function () {
  return intl.format(this);
};

String.prototype.numberFormat = function () {
  return intl.format(this);
};

/**
 *
 */
